var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1999_1055",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.402344,
    y: 0.0200195,
    width: 40.4784,
    height: 40.4784,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1999_1055)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: -7,
    width: 73,
    height: 65,
    fill: "#E70000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1999_1055",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1999_1055",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAABXJJREFUeF7tnT1sHEUUx/+zezH5OJuC4JhAheILSaCNKPjwYVOA+KhAEIlvGiQKRMNHjxTRpIOKBAMBCRrkICGByFmQgo8OE0IuKSgg+CQSKbbBcL7bh/aCzWHveWdn9mNm9qWylLdv3vv/9s3szNzsCvA/oxQQRkXDwYCBGHYTMBAGYpgChoXDFcJADFPAsHC4QhiIYQoYFg5XCAMxTAHDwuEKYSCGKWBYOKlUyMXJPfsp8B7sEmoAdhiWY9bh/OELNNGlj3d+ee6MbmNaQC5N3Xj1SrfyJgGPCJR7XYwAQiA+2LK9+9w1n55fUAWjDCSE0e74p4QQN6s27uR1hLnKtuA2VSjKQFr12vsAHnVSVM2kSOC9sZPNx1TcKAEJx4yVwPuh7N3UIMHD7qvSpQMqY4oSkPl67VUBvKZyB5TlGiGCV0ZPnj+cNF8lIK2J2jEIPJm0sTLZE+joWOPcM0lzVgXyIQQeStpYqewJH+2abT6cNGcGklQxWXsGIqtUTnYMJCehZZthILJK5WTHQHISWrYZBiKrVE52DCQnoWWbYSCySuVkx0ByElq2GSuBEKZ9tA/TyFW/dhfpoCAcgcAtsjmnYkeYI0+84FfxnVj4+/ouhl6GwBPavm0DQhDHxhpnn+5P/ML9u7d7S9UZAUxqCyLjgPCVQOXe0dkfl/rNWxO1t7Wh2AbEp/a+nbM//7Retx6UxeonQqAuo6mqDREawfDSfbtPXPhzvY9we6ETeKdVffeusw2INyxGrp05uxiVdNZQNoMRxnPxnj0jnb+8y6UCQsDUWKP5xaCks4ISB6MHZHL87k4gPisVEBDmusNLt0Z1GatCpA1FBsaVNnd8o/1bAdu6rH/72chBNZOBfsAAvqGtheoJ4eEureqwcQxZS1hWKJ2nL9k20oJhNZArwWdXKbK+04RhPZCsoBQFwwkgaUMpEoYzQNKCUjQMp4DoQjEBhnNAVKGYAsNJIEmhEIaiFgozm2fETVSsnBjGJRU+EW+yCNg/ow//znPWHxu6q0BkZ/SbCdRbDkl7nhFHxGkgkt1XlEaFwHB2DFmvsMSgXdiYsTHWkvy2VxJKYZWxCsb5Luu/RGPXvULT3LeDS1khktXR//SV6x59PxTnKyQhjMKhOA1EEUahUFwFwhPDuAkPgNZELZ8jbRKVsfY0JbBFaulEZ+dRQps1E+cqJAmM1T1w2WvygOIUEFlho5ZDZK/NGoozQGQF3WxtStZHllCcACIrpMxCoayvrKBYD0RWQBkYCWb1mc3orQaSBYyioVgLJEsYRUKxEkgeMIqCYh0Qg39s7S9Wv9Y+yWUbEJOPI7QmxqcgxOdJJuYbbG0Dwgd2onEX9jYgv0v7o964lvaZkEF3OR9p27ijNr1rtvm/l6Dlvu064KHit3rtHQ9Qemei3YuLhOmKH7yOIfzSWRYHCTiifXIpacdPmAPoxco2+hZt3NAO8JIH7/GkbqwfQ7QTNt2BbYO66Xpqx8dAtCVM1wEDSVdPbW8MRFvCdB0wkHT11PbGQLQlTNcBA0lXT21vDERbwnQdMJB09dT2lieQ+freowL0lHbQDjsQwFujjeazSVNUWu3lz1XEy5zr5yp+v2N8X8cXp/mDLtFgCAgq1D4Q9ca8OJRKFRI6nb9z73Hh0aG4Bsr4/wHw7nWNptKKsTKQ3mvwlr1T2nvP7hH7vrI1uD33j4KFOoZQVpbFGxDiUNm7r7CbIuD40NbgeVUYoabKFdJ/Y4djSuDRAwTvpjJ+WBKCzvi0MqMyZqzvIFIB4l6vU1xGDKQ47SNbZiAMxDAFDAuHK4SBGKaAYeFwhTAQwxQwLByuEAZimAKGhcMVwkAMU8CwcLhCDAPyD4UdPaGJRGswAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.ec5496edd6be11f2c608065d65dffc80.svg";
export { ForwardRef as ReactComponent };